export const pageMixin = {
  methods: {
    onLoadingStatus (loading) {
      if (!loading) {
        this.loading = false
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/pageMixin.js